import React from 'react'
import PropTypes from 'prop-types'
import List from 'material-ui/List'
import SubCheckboxItem from './SubCheckboxItem'

const SubListOfCheckboxes=props=>{
    if (props.subAnswers){
        return (
            <div>
                {props.subQuestion? (
                    <h3 className="display-8">{props.subQuestion}</h3> 
                ):null}
                <List disablePadding={true} style={{paddingTop: '0px',paddingBottom: '0px'}}>
                    {props.subAnswers.map(answer=>{
                        return (
                           <SubCheckboxItem 
                             key={answer.field} 
                             field={answer.field} 
                             label={answer.label} 
                             subAnswers={answer.subAnswers}
                             changeFieldValue={props.changeFieldValue}
                            />
                        )
                    })}
                </List>
            </div>    
        )
    }
    return null
}

SubListOfCheckboxes.propTypes = {
    subAnswers: PropTypes.array.isRequired
}

export default SubListOfCheckboxes


// WEBPACK FOOTER //
// ./src/views/ImageCategorisation/SubListOfCheckboxes.js